import axios from 'axios';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN } from '~/constants';
import https from 'https';

export const API_URL = process.env.NEXT_PUBLIC_NESTJS_SERVER;

if (process.env.NODE_ENV === 'development') {
  const httpsAgent = new https.Agent({
    rejectUnauthorized: false,
  });
  axios.defaults.httpsAgent = httpsAgent;
  // eslint-disable-next-line no-console
  console.log(process.env.NODE_ENV, `RejectUnauthorized is disabled.`);
}

const InternalApiAxiosInstance = axios.create({
  validateStatus: function (status) {
    return status == 200 || status == 201;
  },
  withCredentials: true,
  baseURL: `${API_URL}`,
});

InternalApiAxiosInstance.interceptors.request.use(async (config) => {
  const token = Cookies.get(ACCESS_TOKEN);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default InternalApiAxiosInstance;
